import React from "react";
import ProfilePage from "../components/profile/ProfilePage";
const Profile = () => {
    return(
        <>
            <ProfilePage/>
        </>
    );
}
export default Profile;